import React, {Component} from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import {MessageText} from '../../../configs'

import {
 MSG_CONFIRM_SHOW,
 MSG_CONFIRM_HIDE
} from '../../../redux/actions/actionTypes'
import styles from './styles'

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6" className="msgbox-title" >{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    minWidth:600,
    textAlign:"center"
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent:"center"
  },
}))(MuiDialogActions);


class ConfirmBoxContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen:false,
      title:null,
      message:null,
      onOK:null,
      onCancel:null,
      onClosed:null
    }

    const showConfirm=this.showConfirm.bind(this)
    const hideConfirm=this.hideConfirm.bind(this)

    this.handleOKButtonClicked=this.handleOKButtonClicked.bind(this)
    this.handleCancelButtonClicked=this.handleCancelButtonClicked.bind(this)
    this.handleClose=this.handleClose.bind(this)

    //emitter.removeAllListeners();

    window.emitter.addListener(MSG_CONFIRM_SHOW, function(title,message,onOK,onCancel,onClosed) {
        showConfirm(title,message,onOK,onCancel,onClosed)
    })

    window.emitter.addListener(MSG_CONFIRM_HIDE, function() {
        hideConfirm()
    })

  }

  showConfirm(title,message,onOK,onCancel,onClosed){
    this.setState({
      isOpen:true,
      title:title,
      message:message,
      onOK:onOK,
      onCancel:onCancel,
      onClosed:onClosed
    })
 }

hideConfirm(){
  console.log("hideConfirm()")
  this.setState({
    isOpen:false
  })
 }

handleOKButtonClicked(){
  let {onOK}=this.state

  if(onOK){
    onOK()
  }
}

handleCancelButtonClicked(){
  let {onCancel}=this.state

  if(onCancel){
    onCancel()
  }
}
 
handleClose(){
  let {onClosed}=this.state

  if(onClosed){
    onClosed()
  }

    this.setState({isOpen:false})
  }

   render() {  
     let {isOpen,title,message}=this.state

    return(
    <div className="msgbox-container">
    <Dialog id="confirmBoxContainer" onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={isOpen}>
      <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <Typography className="msgbox-body" gutterBottom>
          {message}
        </Typography> 
      </DialogContent>
      <DialogActions>
        <Button onClick={this.handleOKButtonClicked}>
         <div>
          <img src='../../../assets/images/icons/btn-order-check-green.png' />
            <br/>
            <span>{MessageText.APP.MSG_BOX_BUTTON_TEXT_YES}</span>
         </div>
        </Button> 
        <Button onClick={this.handleCancelButtonClicked} >
         <div>
          <img src='../../../assets/images/icons/btn-cancel.png' />
            <br/>
            <span>{MessageText.APP.MSG_BOX_BUTTON_TEXT_NO}</span>
         </div>
        </Button> 
      </DialogActions>
    </Dialog>
  </div>
    )
  }
}

export default ConfirmBoxContainer
